import { QuestionAssignmentDefinition, QuestionDefinition } from '../question';

export enum EventQuestionAssignmentType {
  PreEvent = 'PRE_EVENT',
  EndOfEvent = 'END_OF_EVENT',
  Room = 'ROOM',
  EndOfRoom = 'POST_NATTERING',
}

export type EventQuestionAssignment = QuestionAssignmentDefinition<EventQuestionAssignmentType>;

export type EventQuestionDefinition = QuestionDefinition<EventQuestionAssignment> & {
  postNatteringQuestions?: PostNatteringQuestion[];
};

export type PostNatteringQuestion = QuestionDefinition<
  QuestionAssignmentDefinition<EventQuestionAssignmentType.EndOfRoom>
>;

export type TopicBasicInfo = {
  questionId: number;
  questionTitle: string;
  hasBeenDiscussed: boolean;
};
